module.exports = __webpack_public_path__ + "static/img/img_iot_pt_sy.f5599bfd.png";